module.exports = __webpack_public_path__ + "img/11f8a97.jpg";